import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import { getTermsText } from '../../utils/commonUtils';

const Terms = ({ showTermsText, startDate, TermsLink, margin }) => {
    const termsText = showTermsText && getTermsText(startDate);
    const extraText =
        showTermsText && ' Opening and closing times may be subject to change.';

    return (
        <Styled.Terms margin={margin}>
            {termsText}
            <TermsLink>
                <Styled.TermsLink>
                    18+ and UK only, T&Cs apply, see here.
                </Styled.TermsLink>
            </TermsLink>
            {extraText}
        </Styled.Terms>
    );
};

Terms.defaultProps = {
    startDate: undefined,
    margin: '0  0 20px 0',
    showTermsText: true
};

Terms.propTypes = {
    showTermsText: PropTypes.bool,
    startDate: PropTypes.string,
    TermsLink: PropTypes.func.isRequired,
    margin: PropTypes.string
};

export default Terms;
